import { useEffect } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import idID from 'antd/locale/id_ID';
import jaJP from 'antd/locale/ja_JP';
import koKR from 'antd/locale/ko_KR';
import thTH from 'antd/locale/th_TH';
import viVN from 'antd/locale/vi_VN';
import zhCN from 'antd/locale/zh_CN';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { PAGE_TITLE_KEYS } from './constants/menu';
import { antdTheme } from './theme/antdTheme';
import { router } from './routes';

const ANTD_LOCALES = {
    en: enUS,
    'zh-CN': zhCN,
    th: thTH,
    vi: viVN,
    ja: jaJP,
    ko: koKR,
    id: idID,
};

function App() {
    const { i18n, t } = useTranslation();
    const locale =
        ANTD_LOCALES[i18n.resolvedLanguage as keyof typeof ANTD_LOCALES] || enUS;

    useEffect(() => {
        const updateTitle = () => {
            const titleKey = PAGE_TITLE_KEYS[router.state.location.pathname];
            const appName = t('meta.title');
            document.title = titleKey ? `${appName} — ${t(titleKey)}` : appName;
        };

        updateTitle();
        const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
        description?.setAttribute('content', t('meta.description'));

        return router.subscribe(updateTitle);
    }, [i18n.resolvedLanguage, t]);

    return (
        <ConfigProvider theme={antdTheme} locale={locale}>
            <AntdApp>
                <AuthProvider>
                    <RouterProvider
                        router={router}
                        key={i18n.resolvedLanguage || i18n.language}
                    />
                </AuthProvider>
            </AntdApp>
        </ConfigProvider>
    );
}

export default App;
